import actions from "./lender-submit-actions";
import getters from "./lender-submit-getters";
import mutations from "./lender-submit-mutations";
import state from "./lender-submit-state";
const lenderSubmitStore = {
  state,
  mutations,
  actions,
  getters
};
export default lenderSubmitStore;